export const formatFileSize = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = bytes;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex++;
  }

  let formatted: string;
  if (unitIndex === 0) {
    formatted = value.toString();
  } else if (unitIndex === 1) {
    formatted = Math.round(value).toString();
  } else {
    formatted = value.toFixed(1);
  }

  return `${formatted} ${units[unitIndex]}`;
};
